import { render } from "./NcEmptyState.vue?vue&type=template&id=cae1091a"
import script from "./NcEmptyState.vue?vue&type=script&lang=js"
export * from "./NcEmptyState.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__